/**
 * Product Page Interactions
 * Handles floating ATC and review star hover effects
 */

class ProductInteractions {
  constructor() {
    this.floatingATC = null;
    this.normalATC = null;
    this.chatButton = null;
    this.init();
  }

  init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.setupFloatingATC();
        this.setupLooxHover();
      });
    } else {
      this.setupFloatingATC();
      this.setupLooxHover();
    }
  }

  /**
   * Setup floating add-to-cart button functionality
   */
  setupFloatingATC() {
    this.floatingATC = document.querySelector('.floating-atc');
    this.normalATC = document.querySelector('.payment-buttons');

    if (!this.floatingATC || !this.normalATC) {
      console.log('[Product] Floating ATC elements not found');
      return;
    }

    // Add scroll listener
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    
    console.log('[Product] Floating ATC initialized');
  }

  /**
   * Handle scroll events for floating ATC
   */
  handleScroll() {
    // Get chat button (may not exist initially)
    if (!this.chatButton) {
      this.chatButton = document.querySelector('#dummy-chat-button-iframe');
    }

    const isScrolledPast = this.normalATC.getBoundingClientRect().top < 0;

    if (isScrolledPast) {
      this.floatingATC.classList.add('show');
      if (this.chatButton) {
        this.chatButton.classList.add('move-chat');
      }
    } else {
      this.floatingATC.classList.remove('show');
      if (this.chatButton) {
        this.chatButton.classList.remove('move-chat');
      }
    }
  }

  /**
   * Setup hover effects for Loox review stars
   */
  setupLooxHover() {
    const looxIcons = document.querySelectorAll('.loox-icon');

    if (looxIcons.length === 0) {
      console.log('[Product] No Loox icons found');
      return;
    }

    looxIcons.forEach(icon => {
      icon.addEventListener('mouseover', () => {
        icon.style.color = 'green';
      });

      icon.addEventListener('mouseout', () => {
        icon.style.color = '';
      });
    });

    console.log(`[Product] Loox hover initialized for ${looxIcons.length} icons`);
  }

  /**
   * Cleanup method (useful for SPA transitions)
   */
  destroy() {
    if (this.floatingATC && this.normalATC) {
      window.removeEventListener('scroll', this.handleScroll.bind(this));
    }
  }
}

// Initialize when script loads
new ProductInteractions();

// Also expose globally in case needed
window.ProductInteractions = ProductInteractions;

// Video overlay play button
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.yv-video-overlay-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var video = btn.closest('.yv-video-media').querySelector('video');
  if (!video) return;

  video.play();
  btn.style.display = 'none';
});

// Restore button on pause/end
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.yv-video-media video').forEach(function(video) {
    var btn = video.closest('.yv-video-media').querySelector('.yv-video-overlay-btn');
    if (!btn) return;

    video.addEventListener('pause', function() { btn.style.display = ''; });
    video.addEventListener('ended', function() { btn.style.display = ''; });
  });
});